import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '业务作业',
    type: 'BF_JOB',
}
